import { forwardRef } from 'react';
import styled from '@happymoneyinc/styled-components';
import PropTypes from 'prop-types';
import ThemeWrapper from '../utils/ThemeWrapper/index.js';
import { jsx, jsxs } from 'react/jsx-runtime';

const CardContainer = styled.div`
  width: 100%;
  max-width: 456px;
  background: ${_ref => {
  let {
    theme
  } = _ref;
  return theme.colors.white;
}};
  border: 2px solid ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme.colors.black;
}};
  border-radius: 2px;
  ${_ref3 => {
  let {
    $boxShadowSize,
    $boxShadowTheme,
    theme
  } = _ref3;
  return $boxShadowTheme === 'black' ? `box-shadow: ${theme.globals.boxShadowSizes[$boxShadowSize]} ${theme.colors.black};` : `box-shadow: ${theme.globals.boxShadowSizes[$boxShadowSize]} ${theme.colors[$boxShadowTheme][3]};`;
}}

`;
const Card = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    children,
    className,
    headerTheme,
    boxShadowSize,
    boxShadowTheme,
    testID,
    title
  } = props;
  return /*#__PURE__*/jsx(ThemeWrapper, {
    children: /*#__PURE__*/jsxs(CardContainer, {
      ref: ref,
      $boxShadowSize: boxShadowSize,
      $boxShadowTheme: boxShadowTheme,
      className: className,
      "data-testid": testID,
      children: [title && /*#__PURE__*/jsx(CardHeader, {
        headerTheme: headerTheme,
        children: title
      }), /*#__PURE__*/jsx(CardContent, {
        children: children
      })]
    })
  });
});
const CardHeader = styled.div`
  padding: ${_ref4 => {
  let {
    theme: t
  } = _ref4;
  return `${t.spacing[3]} ${t.spacing[4]} ${t.spacing[4]} ${t.spacing[3]}`;
}};
  text-align: center;
  background-color: ${_ref5 => {
  let {
    headerTheme,
    theme
  } = _ref5;
  return theme.colors[headerTheme][3];
}};
`;
const CardContent = styled.div`
  padding: ${_ref6 => {
  let {
    theme: t
  } = _ref6;
  return `${t.spacing[7]} ${t.spacing[5]}`;
}};
  background: ${_ref7 => {
  let {
    theme
  } = _ref7;
  return theme.colors.white;
}};
`;
Card.defaultProps = {
  children: null,
  className: '',
  headerTheme: 'mojito',
  boxShadowSize: 'normal',
  boxShadowTheme: 'black',
  testID: 'card',
  title: null
};
Card.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string,
  headerTheme: PropTypes.oneOf(['flamingo', 'fire', 'poppy', 'lemon', 'chartreuse', 'mojito', 'azure', 'ultraviolet']),
  boxShadowSize: PropTypes.oneOf(['none', 'normal', 'large']),
  boxShadowTheme: PropTypes.oneOf(['black', 'flamingo', 'fire', 'gray', 'poppy', 'lemon', 'chartreuse', 'mojito', 'azure', 'ultraviolet']),
  testID: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.node, PropTypes.string])
};
var Card$1 = Card;

export { Card$1 as default };
//# sourceMappingURL=Card.js.map
